module.exports = __webpack_public_path__ + "img/55248hlys2.8a10abfc.png";